import React from 'react';

import currencyFormat from 'components/Widgets/currencyFormat';
import Actions from './Actions';

const columns = [
  {
    name: 'Invoice',
    selector: (row) => row.attributes.number,
    sortable: true,
  },
  {
    name: 'Date',
    selector: (row) => row.attributes.created_at_int,
    cell: (row) => row.attributes.created_at_formatted,
    sortable: true,
  },
  {
    name: 'Coach',
    selector: (row) => row.attributes.coach_name,
    sortable: true,
  },
  {
    name: 'Member',
    selector: (row) => row.attributes.members,
    wrap: true,
    sortable: true,
  },
  {
    name: 'Type',
    selector: (row) => row.attributes.invoice_type_name,
    sortable: true,
  },
  {
    name: 'Total',
    selector: (row) => row.attributes.total_price,
    cell: (row) => currencyFormat(row.attributes.total_price),
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    cell: (row) => row.attributes.status_name,
    sortable: true,
  },
  {
    name: 'Actions',
    sortable: false,
    width: '140px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
